module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point2_4-82fd561ea22187df685d7873526baf61.jpg";